import { BehaviorSubject } from 'rxjs';

const forgetPasswordModal$ = new BehaviorSubject(false);
const isFirstTime$ = new BehaviorSubject(false);

const displayForgetPasswordModal = (isShow: boolean, isFirstTime?: boolean) => {
	forgetPasswordModal$.next(isShow);
	isFirstTime$.next(isFirstTime ?? false);
}

export const forgetPasswordService = {
	forgetPasswordModal$: forgetPasswordModal$.asObservable(),
	isFirstTime$: isFirstTime$.asObservable(),
	displayForgetPasswordModal
};